


/// Polyfill for Intersection Observer
require('intersection-observer')



import vue from 'vue'



/// State Management
import VueStash from 'vue-stash'
vue.use(VueStash)



/// Reset & Transitions
import './assets/css/reset.css'
import './assets/css/transitions.css'



/// jQuery Plugins
window.$ = window.jQuery = require('jquery')

import transit from 'jquery.transit'

require('imagesloaded')
require('jquery-unveil')
require('jquery.fullscreen')
require('jquery-touchswipe')
require('jquery-visible')

// require('slick-carousel');
// import 'slick-carousel/slick/slick.css'
// import 'slick-carousel/slick/slick-theme.css'



/// Vanilla Libs
var _ = window._ = require('underscore')
var async = window.async = require('async')

/// Waypoints
// require('waypoints/lib/noframework.waypoints.js')
// require('waypoints/lib/shortcuts/inview.js')



// WEBPACK FOOTER //
// ./src/app-imports.js